<template>
  <a-modal
    title="评价提交成功"
    :visible="visible"
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"
    :footer="null"
  >
    <div style="text-align: center; padding: 20px 0">
      <a-icon type="check-circle" style="font-size: 48px; color: #52c41a" />
      <p style="margin-top: 16px; font-size: 16px">您的评价已成功提交！</p>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  }
}
</script>